<template>
  <div class="mainCon">
    <stu-main-title></stu-main-title>
    <div class="content">
      <ots-table-new
        v-if="!showNull"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :align="center"
      ></ots-table-new>
      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">成绩暂未发布，请等待</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { selectUserInfo } from "@/http/modules/student/ticket";
import {
  getScoreList,
  exportScoreList,
  exportCertificate,
} from "@/http/modules/student/score";
export default {
  name: "stuScore",
  data() {
    return {
      // Reviewitem: "",
      // scoreReviewEndTime: "",
      // scoreReviews: "",
      showNull: false,
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考试科目",
          prop: "course",
        },
        {
          title: "成绩",
          prop: "result",
        },
      ],
      tableData: [],
    };
  },
  created() {
    this.PlanFnId();
    this.getScoreData();
    this.ConfigDataitemts;
  },
  mounted() {
    /* ** 是否可以下载合格证 ** */
    this.isDownLoadScore();
  },
  methods: {
    /*******************************************
     * @isDownLoadScore 判断 - 是否可以下载合格证
     *******************************************/

    isDownLoadScore() {
      let buttons = {
        title: "操作",
        type: "buttons",
        width: "200",
        btnList: [
          {
            title: (val) => {
              if (val.row.isPass == 1)  return "下载合格证";
            },
            click: this.downCertificate,
          },
          {
            title: (val) => {
              return this.scoreReviews == 1 && val.row.isPass == 0 ? val.row.reviewed == 1 ? "查看申诉" : this.scoreReviewEndTime > this.Reviewitem && val.row.scoreType != 1 ? "申诉": "" : "";
            },
            click: this.downRepresentations,
          },
        ],
      };
      this.$api.system.getConfigData().then(({ data }) => {
        data.configList.map((e) => {
          if (e.setName == "needCertificatePrint") {
            if (e.setValue == 1) {
              this.tableHeader.push(buttons);
            } else {
              return false;
            }
          }
          if (e.setName == "showExamCheckState") {
            if (e.setValue == 1) {
              this.tableHeader.push({
                title: "考试状态",
                prop: "checkStateName",
                align:'center'
              });
            } else {
            }
          }
        });
      });
    },
    async getScoreData() {
      const { data: plan } = await getCurrentPlanFn({
        planId: this.getCurrentGlobalPlanId(),
      });
      const { data: user } = await selectUserInfo();
      this.user = user;
      let param = {
        planId: "d403db7d-c9e5-4325-928c-b2b7f3df5acd",
        userId: user.id,
      };
      const { data } = await getScoreList({
        planId: this.getCurrentGlobalPlanId(),
      });
      if (data) {
        this.tableData = data;
      } else {
        this.showNull = true;
      }
    },
    async downScore(val) {
      const { courseId, planId } = val;
      // const { data } = await exportScoreList({cardNo: this.user.cardNo})
      const { data } = await exportScoreList({ courseId, planId });
      if (data) {
        window.location.href = data;
      }
    },
    async ConfigDataitemts() {
      let { data } = await ConfigData();
      data.configList.map((e) => {
        if (e.setValue == 1) {
          this.setValuePrint = 1;
        }
      });
    },
    async PlanFnId() {
      let { data } = await getCurrentPlanFn({
        planId: this.getCurrentGlobalPlanId(),
      });
      console.log(data.scoreReview, 789);
      this.scoreReviews = data.scoreReview;
      this.scoreReviewEndTime = new Date(data.scoreReviewEndTime).getTime();
      this.Reviewitem = new Date().getTime();
    },
    downRepresentations(row) {
      this.$router.push({
        path: "/stuHome/representations",
        query: {
          id: row.planId,
          studentCourseId: row.studentCourseId,
        },
      });
    },
    async downCertificate(row) {
      const { data } = await exportCertificate({
        cardNo: this.user.cardNo,
        planId: row.planId,
        courseId: row.courseId,
      });
      if (data) {
        window.open(data);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}
</style>
